/*
 * Copyright 2024 Palantir Technologies, Inc. All rights reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import * as React from "react";
import type { SVGIconProps } from "../../svgIconProps";
import { IconSize } from "../../iconTypes";
import { SVGIconContainer } from "../../svgIconContainer";

export const ArrowUpLg: React.FC<SVGIconProps> = React.forwardRef<any, SVGIconProps>(({size = IconSize.STANDARD, ...props}, ref) => {
    const isLarge = size! >= IconSize.LARGE;
    const pixelGridSize = isLarge ? IconSize.LARGE : IconSize.STANDARD;
    const translation = `${-1 * pixelGridSize / 0.014705882352941176 / 2}`;
    const style = { transformOrigin: "center" };
    return (
        <SVGIconContainer iconName="arrow-up-lg" ref={ref} size={size} {...props}>
            <path
                d={isLarge ? "M623.3333333333333 226.6666666666668V916.5833333333331L306 599.25L226.6666666666667 680L680 1133.3333333333333L1133.3333333333333 680L1054 599.25L736.6666666666667 916.5833333333331V226.6666666666668H623.3333333333334z" : "M498.6666666666667 181.3333333333333V733.2666666666667L244.8000000000001 479.4L181.3333333333334 544L544 906.6666666666666L906.6666666666669 544L843.2000000000002 479.4L589.3333333333335 733.2666666666667V181.3333333333333H498.6666666666668z"}
                fillRule="evenodd"
                transform={`scale(0.014705882352941176, -0.014705882352941176) translate(${translation}, ${translation})`}
                style={style}
            />
        </SVGIconContainer>
   );
});
ArrowUpLg.displayName = `Blueprint5.Icon.ArrowUpLg`;
export default ArrowUpLg;
